import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43a53cd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dk-page-header dk-page-header--big-hero",
  ref: "header"
}
const _hoisted_2 = { class: "grid grid-cols-8 bg-white px-4 lg:grid-cols-16 lg:px-0" }
const _hoisted_3 = { class: "col-span-8 pt-4 lg:col-span-10 lg:col-start-2 lg:pb-8" }
const _hoisted_4 = ["src", "title"]
const _hoisted_5 = { class: "col-span-6 col-start-2 pb-4 lg:col-span-4 lg:col-start-12 lg:py-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DKBigHeroHeader = _resolveComponent("DKBigHeroHeader")!
  const _component_NoSSR = _resolveComponent("NoSSR")!
  const _component_DKLinkBoxList = _resolveComponent("DKLinkBoxList")!

  return (_ctx.formPage && _ctx.formPageId)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_DKBigHeroHeader, {
          ref: "bigheroHeader",
          genericPage: _ctx.formPage
        }, null, 8, ["genericPage"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_NoSSR, null, {
              default: _withCtx(() => [
                _createElementVNode("iframe", {
                  width: "100%",
                  src: _ctx.formPage.formUrl,
                  title: _ctx.formPage.title,
                  ref: "jotformIframe"
                }, null, 8, _hoisted_4)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_DKLinkBoxList, {
              linkList: _ctx.formPage.links
            }, null, 8, ["linkList"])
          ])
        ])
      ], 512))
    : _createCommentVNode("", true)
}